module.exports = __webpack_public_path__ + "static/media/lainnya.0ec876a1.svg";